import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label, ButtonStandard, ButtonLight, formatMessage } from 'cw-ui-core';
import css from './DeleteUserDialog.scss';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import React, { useEffect } from 'react';

export const DELETE_USER_DIALOG = 'DELETE_USER_DIALOG';

const DeleteUserDialog = ({ onDidMount, onCancel, onOk }) => {
    useEffect(() => {
        onDidMount();
    }, [onDidMount]);

    const dialogButtons = [
        <ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={onCancel}
        />,
        <ButtonStandard
            key="ok"
            automationName="ok"
            className={css.deleteButton}
            value={formatMessage(Locale.delete)}
            onClick={onOk}
        />,
    ];

    return (
        <Dialog dialogId={DELETE_USER_DIALOG} header={formatMessage(Locale.deleteUser)} buttons={dialogButtons}>
            <div className={css.wrap}>
                <div className={layoutCss.podCol}>
                    <ScreenMessagePanelContainer className={css.screenMessage} screenKey={DELETE_USER_DIALOG} />
                    <Label value={formatMessage(Locale.deleteUserConfirmation)} />
                </div>
            </div>
        </Dialog>
    );
};

export default injectIntl(DeleteUserDialog);
